import React from 'react'
import Helmet from 'react-helmet'
import { HeaderSink } from 'components/Header'
import { observer } from 'mobx-react'
import ProjectItem from './ProjectItem'
import ContentLoading from 'components/ContentLoading'
import Modal from 'components/Modal'
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog'

import ContentError from 'components/ContentError'
import ProfileEditor from 'components/ProfileEditor'
import links from 'misc/links'
import intercomUpdate from 'decorators/intercomUpdate'
import GettingStarted from './GettingStarted'
import './styles.sass'

@intercomUpdate({ screen: 'Projects' })
@observer
export default class ProjectsScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.projectsScreenStore.activate()
    this.props.rootStore.profileEditorStore.activate()
  }

  render () {
    const { projectStore, projectsScreenStore, gettingStartedStore, authStore, profileEditorStore } = this.props.rootStore
    return (
      <div className="projects-screen">
        <Helmet title="Projects" />
        <HeaderSink
          // hehehehe
          fabTo={gettingStartedStore.shouldShow === false ? links.newProject() : null}
          pull
        />
        <div className="container">
          <div className="columns is-mobile">
            <div className="column is-8-desktop is-offset-2-desktop has-spacing-top">
              {authStore.user.needsToUpdateProfile &&
                <div className="has-spacing-bottom">
                  <ProfileEditor profileEditorStore={profileEditorStore} />
                </div>
              }
              {!authStore.user.needsToUpdateProfile && projectsScreenStore.activate.match({
                pending: () => <ContentLoading />,
                rejected: (err) => <ContentError error={err} />,
                resolved: () => (
                  projectStore.projects.length === 0
                    ? <GettingStarted store={gettingStartedStore} />
                    : (
                      gettingStartedStore.shouldShow
                        ? <GettingStarted store={gettingStartedStore} />
                        : <ProjectsList projects={projectStore.orderedJobs} />
                    )
                )
              })}
            </div>
          </div>
        </div>
        <Modal isOpened={projectsScreenStore.showingFreeExtensionsInfo} onRequestClose={(() => projectsScreenStore.closeFreeExtensionsInfo())}>
          <Dialog>
            <DialogTitle>Free Extensions</DialogTitle>
            <DialogContent>
              <div className="content is-medium">
                <p>
                  Taxfyle will file your personal and
                  business extensions free of charge.
                </p>
                <p>
                  Simply answer the onboarding questions and we'll take care of the rest.
                </p>
              </div>
            </DialogContent>
            <DialogFooter>
              <DialogButton onClick={() => projectsScreenStore.closeFreeExtensionsInfo()}>Let's go!</DialogButton>
            </DialogFooter>
          </Dialog>
        </Modal>
      </div>
    )
  }
}

const ProjectsList = observer(function ProjectsList ({ projects }) {
  if (projects.length === 0) {
    return null
  }

  const closed = projects.filter(x => x.completed)
  const ongoing = projects.filter(x => !x.completed)
  return (
    <div className="projects-list">
      {ongoing.length > 0 &&
        <div className="list-title animated fadeIn">Current</div>
      }
      <div className="list-container">
        {ongoing.map(project =>
          <ProjectItem project={project} key={project.id}/>
        )}
      </div>
      {closed.length > 0 &&
        <div className="list-title animated fadeIn">Completed</div>
      }
      <div className="list-container">
        {closed.map(project =>
          <ProjectItem project={project} key={project.id}/>
        )}
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/client/screens/Projects/index.jsx